<template>
  <div id="login_main_div" @keyup.enter="submitLogin()">
    <div id="title"></div>
    <div id="main_board">
      <div id="userNameInput">
        <input type="text" id="userName" v-model="userName" ref="userName">
      </div>
      <div id="passwordInput">
        <input type="password" id="password" v-model="password">
      </div>
      <div id="btn" @click="submitLogin()"></div>
    </div>
    <div id="address">
      <a href="http://10.1.200.2" target="_blank">
        <div id="address_one" class="address_div">
          <img class="one_top" src="/static/login/img/lubo.png"/>
          <span class="one_span">录播系统</span>
        </div>
      </a>
      <a href="http://10.1.200.174/erds/" target="_blank">
        <div id="address_two" class="address_div">
          <img class="two_top" src="/static/login/img/oa.png"/>
          <span class="two_span">OA办公系统</span>
        </div>
      </a>
      <a href="http://ordos.youmoo.cn:8080/zzbcms/zhuzhan/" target="_blank">
        <div id="address_three" class="address_div">
          <img class="three_top" src="/static/login/img/wangluoxy.png"/>
          <span class="three_span">鄂尔多斯干部网络培训学院</span>
        </div>
      </a>
      <a href="https://wsdx.ccps.gov.cn/" target="_blank">
        <div id="address_four" class="address_div">
          <img class="four_top" src="/static/login/img/shishikt.png"/>
          <span class="four_span">中央党校网上党校</span>
        </div>
      </a>
     <!-- <a>
        <div id="address_six" class="address_div">
          <img class="six_top" src="/static/login/img/xueyuan.png"/>
          <span class="six_span">学员平台</span>
        </div>
      </a>
      <a>
        <div id="address_seven" class="address_div">
          <img class="seven_top" src="/static/login/img/jiaoyuan.png"/>
          <span class="seven_span">教员平台</span>
        </div>
      </a>-->
    </div>
    <!--<div id="footer">
      <span>版权所有 北京联创众升科技有限公司</span>
      <br/>
      <span>010-82119255  info@u-innovate.com.cn  京ICP备14041451号</span>
    </div>-->
    <img id="qrCodeImg" src="/static/login/img/QRCode.png"/>

  </div>
</template>

<script>
  import {schoolAxios} from '../main';

  export default {
    name: "login",
    data() {
      return {
        userName: "",
        password: ""
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.$refs.userName.focus();
      });
    },
    methods: {
      submitLogin: function () {
        let this_ = this;
        if(this_.userName == "" || this_.password == ""){
          "请输入完整账号密码".showMessage();
          return;
        }
        schoolAxios({
          baseURL: this_.$store.state.ssoBase,
          url: 'sso/oauth/token',
          data: {
            "username": this_.userName,
            "password": this_.password,
            "grant_type": "password",
            "client_id": "Spa",
            "client_secret": "Appsecret_password"
          }
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          //保存或修改登录状态

            //写入登录的用户名
          this_.$store.set("loginUserName", this_.userName);
            //写入登录状态字段
          this_.$store.set("userLoginStatus", true);
            //写入token_type字段
          this_.$store.set("token_type", data.token_type);
            //写入access_token字段
          this_.$store.set("access_token", data.access_token);
            //写入token有效时间
          this_.$store.set("expires_in", data.expires_in);
            //写入刷新token
          this_.$store.set("refresh_token", data.refresh_token);

            let loginTimeStamp = new Date().getTime();
          this_.$store.set("loginTimeStamp", loginTimeStamp);
          //跳转回原来的页面
          let lastVisitPath = decodeURIComponent(this_.$route.query.lastVisitPath || '/');
          /*//跳转到历史路由
          this_.$router.push({
            path: lastVisitPath
          });*/

          //判断角色跳转页面
          this_.getUserData(lastVisitPath);
        }).catch(function (error) {
          if(!error) return;
          if(error.error == 'invalid_grant')
            "请输入正确的账号或者密码".showMessage();
          else{
            error.error_description.showMessage();
          }
        });
      },
      /**
       * 获得studentId
       */
      getUserData(lastVisitPath){
        let this_ = this;
        schoolAxios({
          url: "role/index/judgementRole",
          method: 'post',
          data: {}
        }).then(function (response) {
          let data = response.data;
          if(!data.success){
            (data.message||"获取用户信息失败").showMessage();
            return;
          }
          //保存或修改用户对象

          this_.$store.set("userName", data.data.userName);
          this_.$store.set("userCode", data.data.userCode);
          this_.$store.set("studentId", data.data.studentId);
          this_.$store.set("photoPath", data.data.photoPath);
          this_.$store.set("userId", data.data.userId);
          this_.$store.set("teacherClazzCode", data.data.teacherClazzCode);

          //如果路由地址是“/”则跳转至角色对应首页或无权限
          if(lastVisitPath && lastVisitPath == '\/'){
            if(!data.data.userCode){
              this_.$router.push({
                path: "/noRight"
              });
              return;
            }
            if(data.data.userCode.indexOf(this_.$store.state.leaderUserCode) != -1){
              this_.$router.push({
                path: "/index"
              });
            }else if(data.data.userCode.indexOf(this_.$store.state.easUserCode) != -1){
              this_.$router.push({
                path: "/index"
              });
            }else if(data.data.userCode.indexOf(this_.$store.state.teacherUserCode) != -1){
              this_.$router.push({
                path: "/homeworkManage_tea"
              });
            }else if(data.data.userCode.indexOf(this_.$store.state.studentUserCode) != -1){
              this_.$router.push({
                path: "/homeworkManage_stu"
              });
            }else if(data.data.userCode.indexOf(this_.$store.state.teacherClassUserCode) != -1){
              this_.$router.push({
                path: "/classTea"
              });
            }else if(data.data.userCode.indexOf(this_.$store.state.cateringCode) != -1){
              this_.$router.push({
                path: "/cateringRecord"
              });
            }else{
              this_.$router.push({
                path: "/noRight"
              });
            }

            /*switch (data.data.userCode){
              case this_.$store.state.easUserCode://教务
                this_.$router.push({
                  path: "/index"
                });
                break;
              case this_.$store.state.teacherUserCode://批改老师
                this_.$router.push({
                  path: "/index_tea"
                });
                break;
              case this_.$store.state.studentUserCode://学员
                this_.$router.push({
                  path: "/homeworkManage_stu"
                });
                break;
              case this_.$store.state.teacherClassUserCode://班主任
                this_.$router.push({
                  path: "/noRight"
                });
                break;
              default://其他
                this_.$router.push({
                  path: "/noRight"
                });
                break;
            }*/
          }else {
            //跳转到历史路由
            this_.$router.push({
              path: lastVisitPath
            });
          }
        });
      },
    }
  }

  /**
   * 根据浏览器的屏幕的大小自动调配div的大小
   */
  function getContentSize() {
    let wh = document.documentElement.clientHeight;
    if (document.getElementById("login_main_div")) {
      document.getElementById("login_main_div").style.height = wh;
    }
  }
  window.onload = getContentSize;
  window.onresize = getContentSize;
</script>

<style scoped>
  @import "../assets/css/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login.vue